import React, { useEffect, useState } from "react";
import { Button, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { getDataRequest } from "../../api/serviceMethods";
import { COUPON_URL, PAYMENT_URL } from "../../api/URLs";
import TablePaymentSuper from "./TablePaymentSuper";
import TableNoExpired from "./TableNoExpired";
import { useNavigate } from "react-router-dom";

const TableCouponPage = ({ setLoading, messageModalRef }) => {
    const { t } = useTranslation();
    const [dates, setDates] = useState([null, null]);
    const [paymentData, setPaymentData] = useState([])
    const [memberType, setMemberType] = useState('unexpired');
    const [keyword, setKeyword] = useState('');
    const navigate = useNavigate();
    const [dataObject, setDataObject] = useState({
        type: "",
        method: ""
    })
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
        },
    });

    const handleTabChange = (activeKey) => {
        setTableParams(prevParams => ({
            ...prevParams,
            pagination: {
                ...prevParams.pagination,
                current: 1,
            },
        }));
        if (activeKey === 'unexpired') {
            setMemberType('unexpired');
            setKeyword("")
        }
        else if (activeKey === 'expired') {
            setMemberType('expired');
            setKeyword("")
        }
    };

    const initLoadPayment = async () => {
        setLoading(true);
        await getDataRequest(`${COUPON_URL}`, {
            keyword: keyword.trim(),
            startDate: dates[0] || "",
            endDate: dates[1] || "",
            status:memberType,
            paymentType: dataObject.type,
            paymentMethod: dataObject.method,
            // orderType: memberType,
            pageNo: tableParams.pagination.current,
            sortKeys: { [tableParams.sortField]: tableParams.sortOrder === "ascend" ? "asc" : "desc" },//descend
            pageSize: tableParams.pagination.pageSize,
        }).then(res => {
            setLoading(false);
            if (res.data.length > 0 || res.status === 200) {
                setPaymentData(res?.data);
                setTableParams(prevParams => ({
                    ...prevParams,
                    pagination: {
                        ...prevParams.pagination,
                        total: res.total,
                    },
                }));
            }
        }).catch((err) => {
            setLoading(false);
            console.log("Error", err);
        });
    };
    const [isSearch, setIsSearch] = useState(true)
    useEffect(() => {
        isSearch && initLoadPayment();
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        tableParams?.sortOrder,
        tableParams?.sortField,
        JSON.stringify(tableParams.filters), isSearch, memberType
    ]);

    return (
        <div className="">
        <Tabs
            defaultActiveKey="unexpired"
            className="cusStyle"
            onChange={handleTabChange}
            tabBarExtraContent={
                <Button
                    style={{
                        fontSize: 16,
                        backgroundColor: "#F8E2E8",
                        border: "none",
                        color: "#E50A47",
                        marginRight:"1.5rem"
                    }}
                    danger
                    onClick={() => navigate(`/coupon/create`)}
                >
                    {t("Batch Create Coupons")}
                </Button>
            }
        >
            <Tabs.TabPane tab={t("No Expired")} key="unexpired">
                <TableNoExpired
                    messageModalRef={messageModalRef}
                    paymentData={paymentData}
                    keyword={keyword}
                    setKeyword={setKeyword}
                    tableParams={tableParams}
                    setTableParams={setTableParams}
                    dates={dates}
                    setDates={setDates}
                    setLoading={setLoading}
                    initLoadPayment={() => {
                        setIsSearch(false)
                        setTimeout(() => {
                            setIsSearch(true)
                        }, 100);
                    }}
                    memberType={memberType}
                    dataObject={dataObject} 
                    setDataObject={setDataObject}
                    isSearch={isSearch} setIsSearch={setIsSearch}
                />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t("Expired")} key="expired">
                <TableNoExpired
                    messageModalRef={messageModalRef}
                    paymentData={paymentData}
                    keyword={keyword}
                    setKeyword={setKeyword}
                    tableParams={tableParams}
                    setTableParams={setTableParams}
                    dates={dates}
                    setDates={setDates}
                    initLoadPayment={() => {
                        setIsSearch(false)
                        setTimeout(() => {
                            setIsSearch(true)
                        }, 100);
                    }}
                    memberType={memberType}
                    dataObject={dataObject} 
                    setDataObject={setDataObject}
                    setLoading={setLoading}
                />
            </Tabs.TabPane>
        </Tabs>
        </div>
    );
};

export default TableCouponPage;
